import { useQuery } from "@tanstack/react-query";
import { fetchPublicImageHotspots } from "@/lib/publicImageHotspots";

/**
 * يجلب النقاط التفاعليّة لصورة محدَّدة (scope + scopeId).
 * عامّ: متاح للجميع (RLS select=public).
 */
export function useImageHotspots(scope: string, scopeId: string | undefined | null) {
  return useQuery({
    queryKey: ["image-hotspots", scope, scopeId],
    queryFn: () => fetchPublicImageHotspots(scope, scopeId!),
    enabled: !!scopeId,
    // كاش قصير + إعادة جلب عند العودة للتبويب → الحذف من /admin يظهر فوراً في الواجهة العامّة
    staleTime: 5_000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
}
